import { useMemo } from 'react';
import { useCurrentModule } from '../components';
const LOW_CREDIT_THRESHOLD = 10;
const parseCreditValue = value => {
  if (value === undefined || value === null) {
    return undefined;
  }
  const parsed = typeof value === 'string' ? Number(value) : value;
  return isNaN(parsed) ? undefined : parsed;
};
export const useCredit = () => {
  var _currentProductQuery$, _currentProductQuery$2, _currencyQuery$data;
  const module = useCurrentModule();
  const currentProductQuery = module.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const currencyQuery = module.SDK.studioOfferingApiClient.hooks.useFetchCurrency({});
  const availableCredit = (_currentProductQuery$ = currentProductQuery.data) == null || (_currentProductQuery$ = _currentProductQuery$.currentProduct) == null ? void 0 : _currentProductQuery$.availableCredit;
  const currentPlan = (_currentProductQuery$2 = currentProductQuery.data) == null || (_currentProductQuery$2 = _currentProductQuery$2.currentProduct) == null ? void 0 : _currentProductQuery$2.productName;
  const currency = (_currencyQuery$data = currencyQuery.data) == null ? void 0 : _currencyQuery$data.currency;
  const formatPrice = module.SDK.useFormatPrice();
  const creditData = useMemo(() => {
    const numericValue = parseCreditValue(availableCredit == null ? void 0 : availableCredit.amount);
    const isLowCredit = (numericValue ?? 0) < LOW_CREDIT_THRESHOLD;
    const formattedValue = formatPrice(numericValue) ?? '';
    return {
      rawValue: availableCredit == null ? void 0 : availableCredit.amount,
      numericValue,
      formattedValue,
      isLowCredit,
      currency,
      currentPlan
    };
  }, [availableCredit, formatPrice, currency, currentPlan]);
  const isLoading = currentProductQuery.isLoading || currencyQuery.isLoading;
  const isError = currentProductQuery.isError || currencyQuery.isError;
  return {
    ...creditData,
    isLoading,
    isError
  };
};
//# sourceMappingURL=useCredit.js.map